/**
 * ConversationPhoneSheet — un numéro touché dans un message : « Appeler » ou « Envoyer un SMS », la
 * même feuille pour la messagerie et le chat du live.
 */
import React from "react"

import { ActionSheet } from "../../../../../../design-system"
import { type PhoneAction } from "./conversationLinks"

const TEXTS = {
    /** L'ancien fil proposait « Call » et « Text » (les mots par défaut de sa bibliothèque). */
    call: "Appeler",
    sms: "Envoyer un SMS",
}

export type ConversationPhoneSheetProps = {
    /** Le numéro touché ; `null` : la feuille est fermée. */
    phone: string | null
    onChoose: (action: PhoneAction) => void
    onClose: () => void
}

export function ConversationPhoneSheet({ phone, onChoose, onClose }: ConversationPhoneSheetProps) {
    return (
        <ActionSheet
            visible={phone != null}
            onClose={onClose}
            title={phone ?? undefined}
            items={[
                { icon: "mobile-alt", label: TEXTS.call, onPress: () => onChoose("call") },
                { icon: "comment-dots", label: TEXTS.sms, onPress: () => onChoose("sms") },
            ]}
        />
    )
}
